<template>
  <div class="reg-exam" v-loading="loadingData">
    <div class="page-title">报名缴费</div>
    <div class="top">
      <div class="left">
        <div class="exam-content" v-html="exam.content" />
        <div class="bottom-tips">
          <div class="title">课程说明</div>
          <div class="content-row">* 请务必在本站内支付；</div>
          <div class="content-row">* 缴费后不参加考试的，不退还费用。</div>
        </div>
      </div>
      <div class="right">
        <div class="exam-base-info">
          <div class="row">
            <div class="title">培训期次</div>
            <div class="content">
              {{ exam.name || (exam.major && exam.major.name) || "--" }}
            </div>
          </div>
          <div class="row">
            <div class="title">报名时间</div>
            <div class="content">
              {{
                new Date(exam.enrollStartTime.replace(/-/g, "/")).toISOString()
                  | moment("YYYY.MM.DD")
              }}
              ~
              {{
                new Date(exam.enrollEndTime.replace(/-/g, "/")).toISOString()
                  | moment("YYYY.MM.DD")
              }}
            </div>
          </div>
          <div class="row">
            <div class="title">考试时间</div>
            <div class="content">
              {{
                new Date(exam.examStartTime.replace(/-/g, "/")).toISOString()
                  | moment("YYYY.MM.DD")
              }}
              ~
              {{
                new Date(exam.examEndTime.replace(/-/g, "/")).toISOString()
                  | moment("YYYY.MM.DD")
              }}
            </div>
          </div>
          <div class="row">
            <div class="title">已报名数</div>
            <div class="content">{{ exam.enrollCount }}人</div>
          </div>
        </div>
        <div class="pay-info" v-if="needPay">
          <div class="pay-money-title">实付金额</div>
          <div class="pay-money"><span>￥</span>{{ payAmountText }}</div>
          <div class="pay-method">
            <div class="method-title">支付方式</div>
            <div class="method-options">
              <div
                v-if="isNativePayMode"
                class="pay-option wxpay"
                :class="{ selected: selectedPayMethod === 0 }"
                @click="choosePayMethod(0)"
              >
                <img src="../../assets/home/icon_wxpay.png" />
                <div class="method-name">微信支付</div>
              </div>
              <div
                v-if="isNativePayMode"
                class="pay-option alipay"
                :class="{ selected: selectedPayMethod === 1 }"
                @click="choosePayMethod(1)"
              >
                <img src="../../assets/home/icon_alipay.png" />
                <div class="method-name">支付宝支付</div>
              </div>
              <div
                v-if="isUnionPayMode"
                class="pay-option unionpay"
                :class="{ selected: selectedPayMethod === 2 }"
                @click="choosePayMethod(2)"
              >
                <img src="../../assets/home/icon_unionPay.png" />
                <div class="method-name">银联支付</div>
              </div>
            </div>
          </div>
          <div v-if="selectedPayMethod !== 1" class="pay-qr-code">
            <div class="qr-code-wrapper">
              <vue-qr :text="qrPayUrl" :size="160"></vue-qr>
            </div>
            <div class="tips">
              <img src="../../assets/home/icon_scan.png" />
              <span>{{ scanTipsText }}</span>
            </div>
            <div class="scan-status" :class="scanStatusClass">
              {{ scanStatusText }}
            </div>
          </div>
          <div
            v-else
            class="alipay-btn"
            @click="go2Alipay"
            v-loading="going2Alipay"
          >
            立即支付
          </div>
        </div>
      </div>
    </div>
    <!-- 隐私政策弹窗提醒 -->
    <el-dialog
      title="隐私政策提示"
      width="800px"
      :visible.sync="privacyDialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="privacy-tips">
        欢迎使用e护考培，请您在使用前认真阅读<el-link
          href="/#/userProtocol"
          class="privacy-link"
          target="_blank"
          type="primary"
          >《用户协议》</el-link
        >和<el-link
          href="/#/privacy"
          class="privacy-link"
          target="_blank"
          type="primary"
          >《隐私政策》</el-link
        >，点击“同意并继续”即表示您已阅读并同意全部条款，可继续使用本软件。
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="agree-privacy-btn" @click="privacyDialogVisible = false">
          同意并继续
        </div>
        <div class="disagree-privacy-btn" @click="$router.go(-1)">不同意</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";
import vueQr from "vue-qr";

export default {
  REG_EXAM_NAV_STATE_KEY: "reg_exam_nav_state",
  data() {
    return {
      exam: {
        content: "未知考试信息",
        enrollCount: 0,
        enrollEndTime: "2000-01-01 00:00:00",
        enrollStartTime: "2000-01-01 00:00:00",
        examEndTime: "2000-01-01 00:00:00",
        examStartTime: "2000-01-01 00:00:00",
        firstTimePrice: 0,
        major: { name: "暂无专业" },
        renewalPrice: 0
      }, // 考试相关信息
      selectedPayMethod: 2, // 支付方式，0：微信支付；1：支付宝支付；2：银联支付
      payWay: 1, // 0：原生支付（微信/支付宝）；1：银联支付
      payMethod: ["微信", "支付宝", "银联"],
      arId: -1, // 报考的id
      wxQrCodeHtml: "", // 微信返回的二维码信息
      alipayHtml: "", // 支付宝信息
      wxUrl: "", // 微信支付地址
      unionUrl: "", // 银联支付地址
      going2Alipay: false,
      loadingData: true,
      needPay: false,
      queryTimer: null, // 查询微信支付的定时器
      scanStatus: "WAIT_SCAN",
      scanStatusText: "待扫码",
      privacyDialogVisible: false, // 隐私政策对话框
      currentErId: null,
      skipPrivacyInCurrentFlow: false,
      currentSessionId: null,
      sessionLoading: false,
      paidHandled: false
    };
  },
  components: {
    vueQr
  },
  computed: {
    currentExamType() {
      if (
        this.exam &&
        this.exam.apply &&
        this.exam.apply.examType !== null &&
        this.exam.apply.examType !== undefined
      ) {
        return Number(this.exam.apply.examType);
      }
      if (
        this.exam &&
        this.exam.willExamType !== null &&
        this.exam.willExamType !== undefined
      ) {
        return Number(this.exam.willExamType);
      }
      if (
        this.exam &&
        this.exam.examType !== null &&
        this.exam.examType !== undefined
      ) {
        return Number(this.exam.examType);
      }
      return 0;
    },
    payAmount() {
      const first = this.exam ? this.exam.firstTimePrice : null;
      const renewal = this.exam ? this.exam.renewalPrice : null;
      if (this.currentExamType === 1) {
        return renewal !== null && renewal !== undefined && renewal !== ""
          ? renewal
          : first;
      }
      return first !== null && first !== undefined && first !== ""
        ? first
        : renewal;
    },
    payAmountText() {
      const num = Number(this.payAmount);
      if (Number.isNaN(num)) {
        return "0";
      }
      if (Number.isInteger(num)) {
        return String(num);
      }
      return num.toFixed(2).replace(/\.00$/, "");
    },
    qrPayUrl() {
      if (this.selectedPayMethod === 2) {
        return this.unionUrl || "";
      }
      return this.wxUrl || "";
    },
    scanStatusClass() {
      if (this.scanStatus === "PAID") {
        return "is-paid";
      }
      if (this.scanStatus === "PAYING" || this.scanStatus === "SCANNED") {
        return "is-paying";
      }
      if (this.scanStatus === "FAILED" || this.scanStatus === "CLOSED") {
        return "is-failed";
      }
      return "is-wait";
    },
    isUnionPayMode() {
      return Number(this.payWay) === 1;
    },
    isNativePayMode() {
      return Number(this.payWay) === 0;
    },
    scanTipsText() {
      if (this.selectedPayMethod === 2) {
        return "微信/支付宝/云闪付扫码完成支付";
      }
      return "微信扫码完成支付";
    }
  },
  created: async function() {
    const entryInfo = this.resolveEntryInfo();
    this.currentErId = entryInfo.erId;
    this.skipPrivacyInCurrentFlow = entryInfo.skipPrivacy;
    await this.loadPayWay();
    // 查询试题详情
    this.loadExamData();
  },
  beforeRouteLeave: function(to, from, next) {
    next(false); // 先阻止
    if (this.queryTimer !== null) {
      clearInterval(this.queryTimer);
      this.queryTimer = null;
    }
    next();
  },
  methods: {
    parseValidErId(value) {
      const num = Number(value);
      if (Number.isNaN(num) || num <= 0) {
        return null;
      }
      return num;
    },
    getStoredRegExamNavState() {
      let storageValue = "";
      try {
        storageValue = sessionStorage.getItem(
          this.$options.REG_EXAM_NAV_STATE_KEY
        );
      } catch (e) {
        return null;
      }
      if (!storageValue) {
        return null;
      }
      try {
        const parsed = JSON.parse(storageValue);
        if (!parsed || typeof parsed !== "object") {
          return null;
        }
        if (
          parsed.ts &&
          Number.isFinite(Number(parsed.ts)) &&
          Date.now() - Number(parsed.ts) > 6 * 60 * 60 * 1000
        ) {
          try {
            sessionStorage.removeItem(this.$options.REG_EXAM_NAV_STATE_KEY);
          } catch (e) {
            void e;
          }
          return null;
        }
        return parsed;
      } catch (e) {
        try {
          sessionStorage.removeItem(this.$options.REG_EXAM_NAV_STATE_KEY);
        } catch (error) {
          void error;
        }
        return null;
      }
    },
    resolveEntryInfo() {
      const queryErId = this.parseValidErId(this.$route.query.erId);
      const paramsErId = this.parseValidErId(this.$route.params.erId);
      const storedState = this.getStoredRegExamNavState();
      const storedErId = storedState
        ? this.parseValidErId(storedState.erId)
        : null;

      const erId = queryErId || paramsErId || storedErId;
      const querySkipPrivacy = this.$route.query.skipPrivacy === "1";
      const paramsSkipPrivacy = this.$route.params.skipPrivacy === "1";
      const storedSkipPrivacy =
        !!storedState &&
        storedState.skipPrivacy === true &&
        storedErId !== null &&
        erId === storedErId;

      return {
        erId,
        skipPrivacy: querySkipPrivacy || paramsSkipPrivacy || storedSkipPrivacy
      };
    },
    async fetchExamDetail() {
      if (this.currentErId) {
        return await httpRequest("/app/exam/exam/userExamInfo", "get", {
          erId: this.currentErId
        });
      }
      return await httpRequest("/app/exam/exam", "get", null);
    },
    async loadPayWay() {
      try {
        const res = await httpRequest("/app/setting/pay-way", "get", null);
        if (res && res.code === 200 && res.data) {
          const paraValue = Number(res.data.paraValue);
          this.payWay = paraValue === 0 ? 0 : 1;
        } else {
          this.payWay = 1;
        }
      } catch (e) {
        this.payWay = 1;
      }
      this.selectedPayMethod = this.normalizePayMethod(this.selectedPayMethod);
    },
    isPayMethodAllowed(payMethod) {
      if (this.isUnionPayMode) {
        return payMethod === 2;
      }
      return payMethod === 0 || payMethod === 1;
    },
    normalizePayMethod(payMethod) {
      if (this.isUnionPayMode) {
        return 2;
      }
      return payMethod === 1 ? 1 : 0;
    },
    async regExam() {
      const params = { erId: this.exam.erId };
      const res = await httpRequest("/app/exam/apply", "post", params);
      if (res !== null && res !== undefined && res.code === 200) {
        if (res.data.payStatus === 1) {
          // 已经付款了
          this.needPay = false;
        } else {
          this.needPay = true;
          this.arId = res.data.arId;
          await this.restoreActiveSession();
          if (!this.currentSessionId) {
            this.choosePayMethod(this.selectedPayMethod);
          }
        }
      } else {
        this.$message.error(res.message);
      }
    },
    async loadExamData() {
      const res = await this.fetchExamDetail();
      if (res !== null && res !== undefined && res.code === 200) {
        const data = res.data || {};
        // /app/exam/exam 返回 {exam,apply,newExam}; /userExamInfo 返回 exam详情并可能带 apply
        if (
          data.apply !== null &&
          data.apply !== undefined &&
          (data.exam || data.erId)
        ) {
          this.exam = {
            ...(data.exam || data),
            apply: data.apply
          };
          if (data.apply.payStatus === 1) {
            this.needPay = false;
          } else {
            this.needPay = true;
            this.arId = data.apply.arId;
            await this.restoreActiveSession();
            if (!this.currentSessionId) {
              this.choosePayMethod(this.selectedPayMethod);
            }
          }
        } else {
          this.exam = data.newExam || data;
          if (this.exam && this.exam.erId) {
            await this.regExam();
          } else {
            this.needPay = false;
          }
        }
      }
      this.loadingData = false;

      // 从开票页过来的场景已确认过隐私协议，不再重复弹窗
      this.privacyDialogVisible = !this.skipPrivacyInCurrentFlow;
    },
    setApply(applyFromChild) {
      // 将apply信息传递给live组件中
      this.apply = applyFromChild;
    },
    stopPayStatusPolling() {
      if (this.queryTimer !== null) {
        clearInterval(this.queryTimer);
        this.queryTimer = null;
      }
    },
    startPayStatusPolling() {
      this.stopPayStatusPolling();
      const _this = this;
      this.queryTimer = setInterval(async function() {
        await _this.pollPayStatus();
      }, 5000);
    },
    mapStatusText(status) {
      if (status === "WAIT_SCAN") {
        return "待扫码";
      }
      if (status === "SCANNED") {
        return "已扫码";
      }
      if (status === "PAYING") {
        return "支付中";
      }
      if (status === "PAID") {
        return "已支付";
      }
      if (status === "CLOSED") {
        return "订单已关闭";
      }
      if (status === "FAILED") {
        return "支付失败";
      }
      return "支付状态确认中";
    },
    setScanStatus(status, statusText) {
      this.scanStatus = status || "UNKNOWN";
      this.scanStatusText = statusText || this.mapStatusText(this.scanStatus);
    },
    mapChannelToPayMethod(channel) {
      if (channel === 2) {
        return 0;
      }
      if (channel === 1) {
        return 1;
      }
      return 2;
    },
    buildPayMethodChannel(payMethod) {
      if (payMethod === 0) {
        return 2;
      }
      if (payMethod === 1) {
        return 1;
      }
      return 3;
    },
    applySessionData(data) {
      if (!data) {
        return;
      }
      if (data.channel !== null && data.channel !== undefined) {
        const mappedMethod = this.mapChannelToPayMethod(Number(data.channel));
        this.selectedPayMethod = this.isPayMethodAllowed(mappedMethod)
          ? mappedMethod
          : this.normalizePayMethod(mappedMethod);
      }
      this.currentSessionId = data.sessionId || null;
      if (this.selectedPayMethod === 1) {
        this.alipayHtml = data.formStr || "";
        this.wxUrl = "";
        this.unionUrl = "";
      } else if (this.selectedPayMethod === 2) {
        this.unionUrl = data.qrCode || "";
        this.wxUrl = "";
        this.alipayHtml = "";
      } else {
        this.wxUrl = data.qrCode || "";
        this.unionUrl = "";
        this.alipayHtml = "";
      }
      this.setScanStatus(
        data.status || "WAIT_SCAN",
        data.statusText || this.mapStatusText(data.status)
      );
      if (data.paid === true) {
        this.handlePaidAndRedirect();
      }
    },
    handlePaidAndRedirect() {
      if (this.paidHandled) {
        return;
      }
      this.paidHandled = true;
      this.needPay = false;
      this.setScanStatus("PAID", "已支付");
      this.stopPayStatusPolling();
      this.$alert("支付成功，即将返回首页。", "提示", {
        confirmButtonText: "确定",
        type: "success",
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(() => {
          this.$router.replace("/");
        })
        .catch(() => {
          this.$router.replace("/");
        });
    },
    async restoreActiveSession() {
      if (this.arId < 0) {
        return;
      }
      const res = await httpRequest("/app/pay/session/active", "get", {
        arId: this.arId
      });
      if (!(res && res.code === 200 && res.data)) {
        return;
      }
      if (res.data.hasActive) {
        const activeMethod = this.mapChannelToPayMethod(
          Number(res.data.channel)
        );
        if (!this.isPayMethodAllowed(activeMethod)) {
          await this.choosePayMethod(
            this.normalizePayMethod(activeMethod),
            true
          );
          return;
        }
        this.applySessionData(res.data);
        if (this.selectedPayMethod !== 1) {
          this.startPayStatusPolling();
        } else {
          this.stopPayStatusPolling();
        }
      } else if (res.data.status === "PAID") {
        this.handlePaidAndRedirect();
      } else {
        this.currentSessionId = null;
      }
    },
    async fetchCurrentPayStatus() {
      if (this.currentSessionId) {
        return await httpRequest(
          "/app/pay/session/status/" + this.currentSessionId,
          "get",
          null
        );
      }
      return null;
    },
    async pollPayStatus() {
      const detailRes = await this.fetchExamDetail();
      if (
        detailRes !== null &&
        detailRes !== undefined &&
        detailRes.code === 200
      ) {
        const data = detailRes.data || {};
        if (data.apply !== null && data.apply !== undefined) {
          this.exam = {
            ...(data.exam || data),
            apply: data.apply
          };
          if (data.apply.payStatus === 1) {
            this.handlePaidAndRedirect();
            return;
          }
        }
      }

      const statusRes = await this.fetchCurrentPayStatus();
      if (statusRes && statusRes.code === 200 && statusRes.data) {
        this.applySessionData(statusRes.data);
        if (statusRes.data.paid === true || statusRes.data.status === "PAID") {
          this.handlePaidAndRedirect();
        }
      }
    },
    async choosePayMethod(payMethod, forceSwitch = false) {
      if (this.arId < 0) {
        this.$message.error("报名失败，请刷新页面重试！");
        return;
      }
      const normalizedPayMethod = this.normalizePayMethod(payMethod);
      if (!this.isPayMethodAllowed(normalizedPayMethod)) {
        this.$message.error("当前支付方式不可用");
        return;
      }
      if (this.sessionLoading) {
        return;
      }
      this.selectedPayMethod = normalizedPayMethod;
      this.sessionLoading = true;
      const req = {
        arId: this.arId,
        channel: this.buildPayMethodChannel(this.selectedPayMethod),
        forceSwitch: forceSwitch
      };
      const res = await httpRequest("/app/pay/session/open", "post", req);
      this.sessionLoading = false;
      if (res !== null && res !== undefined && res.code === 200) {
        this.applySessionData(res.data || {});
        if (this.selectedPayMethod === 1) {
          this.stopPayStatusPolling();
        } else {
          this.startPayStatusPolling();
        }
        return;
      }
      if (
        !forceSwitch &&
        res &&
        (res.state === "LOCKED" ||
          (res.message && res.message.indexOf("待支付订单") !== -1))
      ) {
        this.$confirm(
          "当前存在待支付订单，切换支付方式将关闭旧二维码，是否继续？",
          "切换支付方式",
          {
            confirmButtonText: "继续切换",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            this.choosePayMethod(normalizedPayMethod, true);
          })
          .catch(() => {});
        return;
      }
      if (res && res.message) {
        this.$message.error(res.message);
      } else {
        this.$message.error("支付下单失败，请稍后重试");
      }
      if (this.selectedPayMethod !== 1) {
        this.setScanStatus("UNKNOWN", "支付状态确认中");
      }
    },
    go2Alipay() {
      if (this.going2Alipay) {
        return;
      }
      this.going2Alipay = true;
      // 渲染完成后
      this.$nextTick(function() {
        document.forms[0].submit();
        this.going2Alipay = false;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.reg-exam {
  width: 1200px;
  max-width: calc(100% - 24px);
  margin: 30px auto 24px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 26px rgba(23, 45, 80, 0.1);
  overflow: hidden;
  text-align: left;
  .page-title {
    text-align: center;
    color: #2f6ec6;
    font-size: 34px;
    font-weight: 700;
    line-height: 1;
    padding: 28px 20px 0;
  }
  .top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 48px;
    padding: 24px 40px 40px;
    .left {
      flex: 1;
      min-width: 0;
      padding-top: 10px;
      .exam-content {
        line-height: 1.8;
        color: #334155;
        font-size: 15px;
        ::v-deep {
          img {
            max-width: 100%;
          }
        }
      }
      .bottom-tips {
        margin-top: 40px;
        padding-top: 24px;
        border-top: 1px dashed #e2e8f0;
        font-size: 14px;
        color: #64748b;
        .title {
          font-weight: 600;
          color: #334155;
          margin-bottom: 12px;
          font-size: 16px;
        }
        .content-row {
          line-height: 28px;
        }
      }
    }
    .right {
      width: 440px;
      flex: 0 0 440px;
      background: #f8fafc;
      border-radius: 12px;
      padding: 30px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.02);
      border: 1px solid #f1f5f9;

      .exam-base-info {
        font-size: 15px;
        font-weight: 400;
        border-bottom: 1px dashed #cbd5e1;
        padding-bottom: 14px;
        .row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
          .title {
            color: #64748b;
          }
          .content {
            color: #1e293b;
            font-weight: 500;
            text-align: right;
          }
        }
      }
      .pay-info {
        margin-top: 24px;
        .pay-money-title {
          font-size: 15px;
          color: #64748b;
        }
        .pay-money {
          margin-top: 8px;
          color: #ef4444;
          font-size: 42px;
          font-family: DINCondensed-Bold, DINCondensed, sans-serif;
          font-weight: bold;
          span {
            font-size: 20px;
            margin-right: 4px;
          }
        }
        .pay-method {
          margin-top: 28px;
          .method-title {
            font-size: 15px;
            color: #64748b;
            margin-bottom: 12px;
          }
          .method-options {
            display: flex;
            gap: 12px;
          }
          .pay-option {
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 1;
            height: 48px;
            border-radius: 8px;
            border: 1px solid #e2e8f0;
            background: #ffffff;
            cursor: pointer;
            transition: all 0.2s ease;
            box-sizing: border-box;
            img {
              margin-right: 10px;
              width: 32px;
              height: 32px;
            }
            .method-name {
              font-size: 16px;
              font-weight: 500;
              color: #334155;
            }
            &.selected {
              border: 2px solid #00b0ab;
              background: #f0fdfc;
            }
          }
        }
        .pay-qr-code {
          margin-top: 32px;
          display: flex;
          flex-direction: column;
          align-items: center;
          background: #ffffff;
          padding: 24px 20px;
          border-radius: 12px;
          border: 1px solid #e2e8f0;

          .qr-code-wrapper {
            padding: 8px;
            border: 1px solid #f1f5f9;
            border-radius: 8px;
            background: #fff;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
          }
          .tips {
            margin-top: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #f1f5f9;
            padding: 8px 16px;
            border-radius: 20px;
            img {
              width: 16px;
              height: 16px;
              margin-right: 8px;
            }
            span {
              font-size: 13px;
              color: #475569;
              font-weight: 500;
            }
          }
          .scan-status {
            margin-top: 16px;
            width: 100%;
            height: 38px;
            line-height: 38px;
            text-align: center;
            border-radius: 6px;
            font-size: 14px;
            font-weight: 600;
            &.is-wait {
              color: #64748b;
              background: #f8fafc;
              border: 1px solid #e2e8f0;
            }
            &.is-paying {
              color: #0284c7;
              background: #e0f2fe;
            }
            &.is-paid {
              color: #059669;
              background: #d1fae5;
            }
            &.is-failed {
              color: #dc2626;
              background: #fee2e2;
            }
          }
        }
        .alipay-btn {
          height: 48px;
          line-height: 48px;
          margin-top: 40px;
          background: #00b0ab;
          border-radius: 6px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          cursor: pointer;
          text-align: center;
          box-shadow: 0 4px 12px rgba(0, 176, 171, 0.2);
          transition: all 0.3s ease;
          &:hover {
            opacity: 0.9;
            transform: translateY(-1px);
            box-shadow: 0 6px 16px rgba(0, 176, 171, 0.3);
          }
        }
      }
    }
  }
  .privacy-link {
    color: #00b0ab !important;
  }
  .dialog-footer {
    text-align: center;
    .agree-privacy-btn {
      height: 38px;
      line-height: 38px;
      background: rgba(0, 176, 171, 1);
      border-radius: 19px;
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
    }
    .disagree-privacy-btn {
      margin-top: 20px;
      height: 38px;
      line-height: 38px;
      border-radius: 19px;
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(118, 118, 118, 1);
      cursor: pointer;
    }
  }

  @media (max-width: 1080px) {
    .page-title {
      font-size: 28px;
      padding-top: 22px;
    }
    .top {
      flex-direction: column;
      padding: 24px 20px 14px;
      gap: 20px;
      .left {
        max-width: none;
        width: 100%;
      }
      .right {
        width: 100%;
        flex: 1 1 auto;
      }
    }
    .bottom {
      margin: 0 20px 20px;
    }
  }
}
</style>
